import { useState } from "react";
import styles from "./style.module.scss";
import VectorIcon from "../../../assets/icons/VactorIcon";
import classNames from "classnames";
import { useSelector } from "react-redux";
import { getTempExportCount } from "../../../redux/SingleDataset/selectors";
import MultiSelect, { Option } from "../../uikit/FormFields/SelectList";
import VLButton from "../../uikit/Buttons/VLButton";
import AddTagIcon from "../../../assets/icons/AddTagIcon";
import { useExportSelection } from "../../../hooks/useExportSelection";
import VLFloatGroup from "views/uikit/VLFloatGroup";
import { ActionItem } from "views/pages/DataPage/CardsView/DataList";

type FloatingPanelType = "buttons" | "selectList";

interface BaseFloatingPanelProps {
  type: FloatingPanelType;
}

interface FloatingPanelButtonsProps extends BaseFloatingPanelProps {
  type: "buttons";
  actionList: ActionItem[];
}

interface FloatingPanelSelectListProps extends BaseFloatingPanelProps {
  type: "selectList";
  options: Option[];
  onOptionSelect: (selectedValues: string[]) => void | Promise<void>;
}

type FloatingPanelProps =
  | FloatingPanelButtonsProps
  | FloatingPanelSelectListProps;

export default function FloatingPanel({ ...props }: FloatingPanelProps) {
  const [showMultiSelect, setShowMultiSelect] = useState(false);
  const exportCount = useSelector(getTempExportCount);
  const { handleClearAll, handleSelectAll, handleMultiSelectChange } =
    useExportSelection();

  const renderByType: Record<FloatingPanelType, React.ReactNode> = {
    selectList: (
      <>
        <VLButton
          type="primary"
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setShowMultiSelect((prev) => !prev);
          }}
          text={"Assign Class"}
          icon={<AddTagIcon />}
        />
        {showMultiSelect && (
          <div className={styles.multiSelectDropdown}>
            <MultiSelect
              options={(props as FloatingPanelSelectListProps).options}
              open={showMultiSelect}
              placement="topLeft"
              placeholder="Search"
              onDropdownVisibleChange={(visible: boolean) =>
                setShowMultiSelect(visible)
              }
              onChange={(selectedValues) =>
                handleMultiSelectChange(
                  selectedValues,
                  (props as FloatingPanelSelectListProps).onOptionSelect,
                )
              }
            />
          </div>
        )}
      </>
    ),
    buttons: (
      <div>
        <VLFloatGroup
          actionList={(props as FloatingPanelButtonsProps).actionList}
          placement="topRight"
          buttonSize="large"
        />
      </div>
    ),
  };

  const renderSelection: Record<FloatingPanelType, React.ReactNode> = {
    selectList: (
      <>
        <div className={classNames(styles.buttonWrapper, styles.child)}>
          <VLButton
            type="text"
            onClick={handleSelectAll}
            text={" Select All"}
          />
        </div>
        <div className={classNames(styles.buttonWrapper, styles.child)}>
          <VLButton
            type="text"
            onClick={handleClearAll}
            text={"Clear Selection"}
          />
        </div>
      </>
    ),
    buttons: <></>,
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.innerWrapper}>
        <div className={classNames(styles.selectedCount, styles.child)}>
          <VectorIcon />
          <span className={styles.count}>{exportCount}</span>
        </div>
        <div className={classNames(styles.divider, styles.child)} />
        <div className={classNames(styles.multiSelectWrapper, styles.child)}>
          {renderByType[props.type]}
          {renderSelection[props.type]}
        </div>
      </div>
    </div>
  );
}
